export default "__VITE_ASSET__BEYxVW9H__"